"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVersionInfo = exports.PackageType = void 0;
const tslib_1 = require("tslib");
const client_core_1 = require("@sensenet/client-core");
const react_1 = require("react");
const use_repository_1 = require("./use-repository");
/*
 * The type of a specific package
 */
var PackageType;
(function (PackageType) {
    /**
     * Can contain small repeatable activities that do not perform significant changes but can be important because of business or technical reasons. A good example is performing an undo checkout on multiple content. Executing a package of this level does not change the application's or the product's version number but the execution is logged and registered
     */
    PackageType[PackageType["Tool"] = 0] = "Tool";
    /**
     * Contains small modifications (e.g. a couple of new content to import or a bugfix in a dll). Usually patches form a chain where every package assumes the existence of all the previous ones but it is not mandatory. It is possible to control this behavior, see version control below.
     */
    PackageType[PackageType["Patch"] = 1] = "Patch";
    /**
     *  An application's first package must be an 'install' package. This is the package that injects a new application into the system. Only Application packages can be set on this level. An install level package must contain a new application identifier that is unknown to the system. Packages on this level can be executed only once.
     */
    PackageType[PackageType["Install"] = 2] = "Install";
})(PackageType = exports.PackageType || (exports.PackageType = {}));
/**
 * Returns the current repository's Version Info values and also checks if the installed components has an updated version on https://nuget.org
 */
const useVersionInfo = () => {
    const [versionInfo, setVersionInfo] = react_1.useState();
    const [nugetManifests, setNugetManifests] = react_1.useState([]);
    const [hasUpdates, setHasUpdates] = react_1.useState(false);
    const repo = use_repository_1.useRepository();
    react_1.useEffect(() => {
        ;
        (() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            const result = yield repo.executeAction({
                idOrPath: client_core_1.ConstantContent.PORTAL_ROOT.Path,
                body: undefined,
                method: 'GET',
                name: 'GetVersionInfo',
            });
            const nugetPromises = result.Components.filter((component) => !component.ComponentId.toLocaleLowerCase().includes('demo') &&
                !component.ComponentId.toLocaleLowerCase().includes('aspose')).map((component) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
                try {
                    const response = yield fetch(`https://api.nuget.org/v3/registration3-gz-semver2/${component.ComponentId.toLowerCase()}/index.json`);
                    if (response.ok) {
                        const nugetManifest = yield response.json();
                        return nugetManifest;
                    }
                }
                catch (error) {
                    return {};
                }
            }));
            const loadedManifests = (yield Promise.all(nugetPromises)).filter((m) => m);
            setNugetManifests(loadedManifests);
            let hasOneUpdate = false;
            result.Components = result.Components.map((component) => {
                const nugetManifest = loadedManifests.find((m) => m['@id'] ===
                    `https://api.nuget.org/v3/registration3-gz-semver2/${component.ComponentId.toLocaleLowerCase()}/index.json`);
                const updateAvailable = nugetManifest ? nugetManifest.items[0].upper > component.Version : false;
                if (updateAvailable) {
                    hasOneUpdate = true;
                }
                return Object.assign(Object.assign({}, component), { NugetManifest: nugetManifest, IsUpdateAvailable: updateAvailable });
            });
            setHasUpdates(hasOneUpdate);
            setVersionInfo(result);
        }))();
    }, [repo]);
    return { versionInfo, nugetManifests, hasUpdates };
};
exports.useVersionInfo = useVersionInfo;
//# sourceMappingURL=use-version-info.js.map